import { sanitizeHeadingText } from "./sanitizeHeadingText";

export function buildTocHeadingId(blockId: string, level: number, text: string): string {
  return `${blockId}-h${level}-${sanitizeHeadingText(text.trim())}`;
}
